import PropTypes from 'prop-types';
import React from 'react';

export default class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      modalProps: {},
    };
  }

  showModal = (modalProps) => {
    this.setState({ showModal: true, modalProps });
  };

  hideModal = () => {
    this.setState({ showModal: false });
  };

  render() {
    const { render } = this.props;
    const { modalProps, showModal } = this.state;
    return showModal && render(modalProps);
  }
}

Modal.propTypes = {
  render: PropTypes.func.isRequired,
};
